const initialState = {
	id: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "SET_JERSEY_FORM_RECORD_ID":
			return {
				...state,
				id: action.id
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/custom/jerseyForm.js